import React, { useRef } from 'react';
import { useState } from 'react';
// @ts-ignore
import moment from 'moment';
import Modal from '../../../../Components/Modal/Modal';
import { useTreatmentContext } from '../../../../Services/TreatmentContext';
import { Size } from '../../../../Enums/Size.enum';
import HealthPlanVaccination from './HealthPlanVaccination';

interface HealthPlanVaccinationModalProps {
	opened: boolean;
	onClose: any;
	disableSubmit?: boolean;
}

export default function HealthPlanVaccinationModal(
	props: HealthPlanVaccinationModalProps,
) {
	const { opened, onClose, disableSubmit } = props;
	const { isCase } = useTreatmentContext();

	return (
		<Modal opened={opened} onClose={onClose} wrapChat={isCase} size={Size.LG}>
			<Modal.Header title={'component.healthPlan.item.vaccination'} />
			<Modal.Content contentScroll={true}>
				<HealthPlanVaccination
					onSuccess={onClose}
					disableSubmit={disableSubmit}
				/>
			</Modal.Content>
		</Modal>
	);
}
